module.exports = __webpack_public_path__ + "static/media/tap-03.2f1691cc.png";